import PropTypes from 'prop-types';
import {CreateUpdateEntityDialog} from '@ozgene/gp5.components.create-update-entity-dialog';
import {saveMetricUnit} from 'Consumables/service/ConsumableService';
import MetricUnitEditor from 'Consumables/components/MetricUnitEditor';

export default function UpdateCreateMetricUnitDialog(props) {
  const {entity, closeDialog} = props;
  const handleSave = async (consumable) => {
    const {error} = await saveMetricUnit(consumable);

    closeDialog();

    if (error) {
      return;
    }
  };

  return (
    <CreateUpdateEntityDialog
      entityType="Unit"
      entity={entity}
      EditorComponent={MetricUnitEditor}
      onSave={handleSave}
      onClose={closeDialog}
    />
  );
}

UpdateCreateMetricUnitDialog.propTypes = {
  entity: PropTypes.shape({
    name: PropTypes.string,
  }),
  closeDialog: PropTypes.func.isRequired,
};

UpdateCreateMetricUnitDialog.contextTypes = {
  router: PropTypes.object.isRequired,
};

UpdateCreateMetricUnitDialog.defaultProps = {
  entity: null,
};
